import React from "react";
import ContactDetailsThankyou from "../ContactDetailsThankyou/ContactDetailsThankyou";

const ContactThankYouLayout = () => {
  return <ContactDetailsThankyou />;
};

export default ContactThankYouLayout;
